import { type ComponentType } from "react";

import { create } from "zustand";

type TyPopupAnim = "scale" | "scaleTop" | "scaleBottom" | "fade" | "bottomSlide" | "topSlide" | "startSlide" | "endSlide";
type TyPopupPlace = "center" | "top" | "bottom" | "end" | "anchor-below" | "anchor-above";
type TyPopupCover = "shaded" | "invisible";

export type TyAnchorRect = {
    top: number;
    left: number;
    right: number;
    bottom: number;
    width: number;
    height: number;
};

export type TyPopupComp = {
    name: string;
    Component: ComponentType<{ onClose: () => void; details?: any }>;
    details?: any;
    anim?: TyPopupAnim;
    place?: TyPopupPlace;
    anchor?: TyAnchorRect;
    cover?: TyPopupCover;
    coverClose?: boolean;
};

type TyPopupState = {
    comps: TyPopupComp[];
    addComp: (comp: TyPopupComp) => void;
    removeComp: (name: string) => void;
};

const usePopupStore = create<TyPopupState>((set) => ({
    comps: [],
    addComp: (comp) =>
        set((state) => ({
            comps: [
                ...state.comps,
                {
                    ...comp,
                    anim: comp.anim ?? "fade",
                    place: comp.place ?? "center",
                    cover: comp.cover ?? "shaded",
                    coverClose: typeof comp.coverClose === "boolean" ? comp.coverClose : true,
                },
            ],
        })),
    removeComp: (name) =>
        set((state) => ({
            comps: state.comps.filter((c) => c.name !== name),
        })),
}));

export default usePopupStore;
